import { render, staticRenderFns } from "./BitQConcerti.vue?vue&type=template&id=5ae52cf2&scoped=true"
import script from "./BitQConcerti.vue?vue&type=script&lang=js"
export * from "./BitQConcerti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae52cf2",
  null
  
)

export default component.exports